export default "__VITE_ASSET__968a21a7__"